/* eslint-disable */
import { regionSettingsMessages } from '@ringcentral-integration/commons/modules/RegionSettings/regionSettingsMessages';
export default {
  region: 'Região',
  [regionSettingsMessages.saveSuccess]: 'Definições guardadas com sucesso.',
  [regionSettingsMessages.dialingPlansChanged]:
    'A região anterior já não é suportada na sua conta.\n    Verifique o novo {regionSettingsLink}.',
  regionSettings: 'definições de região',
  [regionSettingsMessages.areaCodeInvalid]:
    'Introduza um indicativo de zona válido.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"[regionSettingsMessages.saveSuccess]"@#@ @source: @#@"Settings saved successfully."@#@
// @key: @#@"[regionSettingsMessages.dialingPlansChanged]"@#@ @source: @#@"The previous region is no longer supported for your account.\n    Please verify your new {regionSettingsLink}."@#@
// @key: @#@"regionSettings"@#@ @source: @#@"region settings"@#@
// @key: @#@"[regionSettingsMessages.areaCodeInvalid]"@#@ @source: @#@"Please enter a valid area code."@#@
